<template>
    <el-container class="i-body">
      <el-aside class="i-side" width="270px" v-show="aside">
        <tree></tree>
      </el-aside>
      <el-main class="i-main">
        <div class="map-shadow elevation-1"></div>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>
</template>

<script>
import tree from '@/components/tree'
export default {
  name: 'layout-tree',
  props: {
    aside: {
      type: Boolean,
      default: true
    }
  },
  components: {
    tree
  }
}
</script>

<style lang="scss" scoped>
  .i-body {
    .i-side {
      padding: 20px;
      border-right: 1px solid #DCDFE6;
    }
    .i-main {
      padding: 24px 16px;
      //padding: 0;
      background-color: #FAFAFA;
      position: relative;
      .map-shadow {
        position: absolute;
        padding: 0;
        margin: 0;
        left: 0;
        top: -10px;
        height: 10px;
        width: 100%;
        z-index: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/layout-tree.vue